import { withStyles } from "@material-ui/core";
import FormSectionHeader from "../common/FormSectionHeader";
import { memo } from "react";
import { StyledSelect } from "../components/Select";
import Details from "./Details";
import { getEquipmentSuffix } from "../../../../utils/utils";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: "4px",
    padding: 8,
    justifyContent: "space-between",
  },
  dropdownContainer: {
    width: "25%",
  },
  driverName: {
    display: "block",
    fontSize: 14,
    color: theme.HeaderSelectedText,
    fontWeight: 600,
    marginTop: 4,
  },
  detailsContainer: {
    lineHeight: 2.5,
  },
});

const DriverDetails = ({
  classes,
  drivers,
  selectedDriver,
  handleDriverChange,
  driverRoute,
  showTrailerScac,
}) => {
  return (
    <>
      <FormSectionHeader label="Driver Assignment" />
      <div className={classes.container} id="driverDetails">
        <div className={classes.dropdownContainer}>
          <StyledSelect
            data={drivers}
            textFieldProps={{
              id: "driver",
              variant: "outlined",
              label : "Select Driver"
            }}
            onChange={handleDriverChange}
            value={selectedDriver}
          />
          <span className={classes.driverName}>{driverRoute?.driverName}</span>
        </div>
        {selectedDriver && (
          <>
            <Details
              label="Tractor : "
              value={driverRoute?.tractorNumber ?? ""}
              containerClass={classes.detailsContainer}
            />
            <Details
              label="Route : "
              value={driverRoute?.routeName ?? ""}
              containerClass={classes.detailsContainer}
            />
            <Details
              label="Manifest : "
              value={driverRoute?.manifestNumber ?? ""}
              containerClass={classes.detailsContainer}
            />
            <Details
              label="Trailer : "
              value={`${driverRoute?.trailerNumber ?? ""} 
                ${getEquipmentSuffix({
                  equipmentScac: driverRoute?.trailerScac,
                  showTrailerScac,
                })
              }`}
              containerClass={classes.detailsContainer}
            />
          </>
        )}
      </div>
    </>
  );
};

export default withStyles(styles)(memo(DriverDetails));
